module.exports = __webpack_public_path__ + "static/media/home-2-comp.94b6dd40.mp4";